import {
  type AuthConfirmResetPasswordT,
  type AuthLoginCredentialsT,
  type AuthRegisterCredentialsT,
} from '@ruminati/types_v2/auth'
import { type UserWithOrganisationsAndRelationshipsT } from '@ruminati/types_v2/user'
import { useMutation } from '@tanstack/vue-query'

import { CommonApiV2Instance } from '@/services/common'

async function registerWithCredentials(details: AuthRegisterCredentialsT) {
  return CommonApiV2Instance.post('auth/register', {
    json: details,
  }).json<UserWithOrganisationsAndRelationshipsT>()
}

async function loginWithCredentials(details: AuthLoginCredentialsT) {
  return CommonApiV2Instance.post('auth/login', {
    json: details,
  }).json<UserWithOrganisationsAndRelationshipsT>()
}

async function sendVerificationEmail(details: { email: string }) {
  await CommonApiV2Instance.post('auth/verify-email', {
    json: details,
    headers: { 'content-type': undefined },
  })
}

async function sendForgotPasswordEmail(details: { email: string }) {
  await CommonApiV2Instance.post('auth/forgot-password', {
    json: details,
    headers: { 'content-type': undefined },
  })
}

async function confirmResetPassword(details: AuthConfirmResetPasswordT) {
  await CommonApiV2Instance.post('auth/confirm-reset-password', {
    json: details,
    headers: { 'content-type': undefined },
  })
}

export async function requestLogout() {
  await CommonApiV2Instance.post('auth/logout', {
    headers: { 'content-type': undefined },
  })
}

export function useRegisterWithCredentialsMutation() {
  return useMutation({ mutationFn: registerWithCredentials })
}

export function useLoginWithCredentialsMutation() {
  return useMutation({ mutationFn: loginWithCredentials })
}

export function useSendVerificationEmailMutation() {
  return useMutation({ mutationFn: sendVerificationEmail })
}

export function useSendForgotPasswordEmailMutation() {
  return useMutation({ mutationFn: sendForgotPasswordEmail })
}

export function useConfirmResetPasswordMutation() {
  return useMutation({ mutationFn: confirmResetPassword })
}

export function useLogoutMutation() {
  return useMutation({ mutationFn: requestLogout })
}
